/*
  Styles partages des champs du formulaire admin prop firms.

  Les `<select>` de ce formulaire etaient rendus en `h-7` avec un `text-xs` :
  28px de haut pour une police dont la boite de ligne native depasse cette
  hauteur, si bien que les libelles longs ("EOD Trail (fin de journee)")
  etaient rognes en bas. Ils sont alignes ici sur `h-8`, la meme hauteur que
  les `Input` voisins, et dotes du meme anneau de focus, pour qu'un select se
  lise et se repere comme un champ de saisie et non comme du texte inerte.

  AUCUN `leading-*` ici, volontairement, et c'est le point contre-intuitif :
  un `<select>` natif positionne son texte via sa `line-height`, pas via un
  centrage de boite. Poser `leading-none` reduit la boite de ligne a la
  hauteur de la police, si bien que les descendantes (le "j" de "journee", le
  "e" accentue) tombent SOUS cette boite et se font rogner -- exactement le
  symptome que cette classe existe pour supprimer. `Input` ne pose pas non
  plus de `leading`, et c'est pour la meme raison : le centrage par defaut du
  navigateur est ce qui tient sur toutes les tailles de police.
*/
export const SELECT_CLASS =
  "w-full h-8 text-xs rounded-md border border-input bg-background px-2 pr-7 shadow-sm " +
  "transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring " +
  "disabled:cursor-not-allowed disabled:opacity-50";
